import { CSSObject } from '@emotion/react';

export const wordWrap: CSSObject = {
  overflowWrap: 'break-word',
  wordWrap: 'break-word',
  hyphens: 'auto',
};
